import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import ReactTable from 'react-table';
import { Grid, Icon } from 'semantic-ui-react';
import * as _ from 'lodash';

import { ApplicationFieldEnum as Fields } from 'Common/FieldEnum';
import { GridContextMenu } from 'Components/app/contextmenu/ContextMenuManager';
import { formatFrequency } from 'Pages/manageapplication/helpers/hub';

import {
  getIconNameFromId,
  navigateToEditBasedOnId,
} from '../../helpers/Helpers';
import { removeIncome } from '../../state/hub/actions';

class IncomeTable extends Component {
  onEdit = (value) => {
    navigateToEditBasedOnId(value.Id, this.props.familyId, this.props.history);
  };

  onRemoveIncome = (value) => {
    this.props.removeIncome(value.Id);
  };

  menuOptions = [
    {
      icon: 'pencil',
      text: 'Edit',
      handler: this.onEdit,
    },
    {
      icon: 'remove',
      text: 'Remove Income',
      handler: this.onRemoveIncome,
    },
  ];

  columns = [
    {
      Header: <strong className={'text-orange'}>Member Income</strong>,
      columns: [
        {
          id: 'Icon',
          sortable: false,
          resizable: false,
          width: 35,
          style: { textAlign: 'center' },
          Cell: (props) => {
            const row = props.original;

            return (
              <Fragment>
                <Icon
                  color={
                    _.has(row, 'Exceptions.IsEmancipatedMinor') &&
                    row.Exceptions.IsEmancipatedMinor
                      ? 'blue'
                      : 'black'
                  }
                  name={getIconNameFromId(props.original.Id)}
                />
              </Fragment>
            );
          },
        },
        {
          id: 'Name',
          Header: 'Name',
          sortable: true,
          width: 200,
          Cell: (props) => {
            return (
              <Fragment>
                {props.original.FirstName} {props.original.LastName}
              </Fragment>
            );
          },
        },
        {
          id: Fields.Income1,
          Header: 'Salary',
          sortable: true,
          width: 140,
          Cell: (props) => {
            return (
              <Fragment>
                {formatFrequency(
                  props.original.Income.Freq1,
                  props.original.Income.Income1
                )}
              </Fragment>
            );
          },
        },
        {
          id: Fields.Income2,
          Header: 'Welfare/Alimony/Child Support',
          sortable: true,
          width: 205,
          Cell: (props) => {
            return (
              <Fragment>
                {formatFrequency(
                  props.original.Income.Freq2,
                  props.original.Income.Income2
                )}
              </Fragment>
            );
          },
        },
        {
          id: Fields.Income3,
          Header: 'Retirement/Pension/Social Security',
          sortable: true,
          width: 225,
          Cell: (props) => {
            return (
              <Fragment>
                {formatFrequency(
                  props.original.Income.Freq3,
                  props.original.Income.Income3
                )}
              </Fragment>
            );
          },
        },
        {
          id: Fields.Income4,
          Header: 'Other',
          sortable: true,
          Cell: (props) => {
            return (
              <Fragment>
                {formatFrequency(
                  props.original.Income.Freq4,
                  props.original.Income.Income4
                )}
              </Fragment>
            );
          },
        },
        {
          id: 'Menu',
          style: { textAlign: 'center' },
          Cell: (gridProps) => {
            if (
              this.props.isReadOnly ||
              gridProps.original[Fields.EmancipatedStudentId]
            ) {
              return null;
            }

            return GridContextMenu({ gridProps, options: this.menuOptions });
          },
          width: 40,
          sortable: false,
        },
      ],
    },
  ];

  render() {
    return (
      <Grid>
        <Grid.Row>
          <Grid.Column>
            <ReactTable
              className={'grid--fixed-row-height'}
              columns={this.columns}
              data={this.props.incomeData}
              loading={false}
              minRows={5}
              pageSize={5}
              showPageJump={false}
              showPageSizeOptions={false}
              filterable={false}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {};
};

IncomeTable = withRouter(
  connect(mapStateToProps, { removeIncome })(IncomeTable)
);

export { IncomeTable };



// WEBPACK FOOTER //
// ./src/pages/manageapplication/components/hub/IncomeTable.js